import { render, staticRenderFns } from "./goal.vue?vue&type=template&id=9e8de0be&"
import script from "./goal.vue?vue&type=script&lang=ts&"
export * from "./goal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports